import { render, staticRenderFns } from "./accountList.vue?vue&type=template&id=a2f96836&scoped=true&lang=html&"
import script from "./accountList.vue?vue&type=script&lang=js&"
export * from "./accountList.vue?vue&type=script&lang=js&"
import style0 from "./accountList.vue?vue&type=style&index=0&id=a2f96836&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f96836",
  null
  
)

export default component.exports